import { Component } from 'react';
import { debounce } from 'lodash/fp';
import { setQueryString } from 'utils/url';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

class ImageDataProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      totalImages: 0,
      loading: true,
      page: 1,
      totalPages: 0,
      query: '',
    };
    this.fetchImages = this.fetchImages.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.reloadOnDelete = this.reloadOnDelete.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.firstPage = this.firstPage.bind(this);
  }

  static default = {
    infinite: false,
  };

  get hasMore() {
    return this.state.totalPages > this.state.page;
  }

  componentDidMount() {
    this.fetchImages();
  }

  fetchImages() {
    const { infinite } = this.props;
    this.setState({ loading: true }, () => {
      request
        .get(
          setQueryString(routes.IMAGES, {
            page: this.state.page,
            query: this.state.query,
          }),
        )
        .then(response => {
          this.setState(state => ({
            images:
              infinite && state.page > 1
                ? state.images.concat(response.data)
                : response.data,
            totalImages: response.totalImages,
            totalPages: response.totalPages,
            loading: false,
          }));
        });
    });
  }

  handlePageChange(page) {
    this.setState({ page }, this.fetchImages);
  }

  getNextPageNumberOnDelete() {
    const { page: currentPage, images } = this.state;
    return images.length === 1 ? Math.max(currentPage - 1, 1) : currentPage;
  }

  reloadOnDelete() {
    this.setState({ page: this.getNextPageNumberOnDelete() }, this.fetchImages);
  }

  updateQuery = debounce(300, query => {
    this.setState({ query, page: 1 }, this.fetchImages);
  });

  loadMore() {
    if (this.hasMore) {
      this.setState(state => ({ page: state.page + 1 }), this.fetchImages);
    }
  }

  firstPage() {
    this.setState({ page: 1 }, this.fetchImages);
  }

  render() {
    const { page, loading, totalPages, images, totalImages, query } =
      this.state;
    return this.props.children({
      loading,
      images,
      totalImages,
      page,
      query,
      hasMore: this.hasMore,
      loadMore: this.loadMore,
      firstPage: this.firstPage,
      reloadOnDelete: this.reloadOnDelete,
      updateQuery: this.updateQuery,
      reload: this.fetchImages,
      paginationProps: {
        page,
        onPageChange: this.handlePageChange,
        pageCount: totalPages,
      },
    });
  }
}

export default ImageDataProvider;
